<!-- 审核弹窗 -->
<template>
  <el-dialog
    title="审核"
    v-model="visible"
    width="30%"
    :close-on-click-modal="false"
  >
    <template #footer>
      <span class="dialog-footer">
        <el-button type="danger" @click="visible = false">驳回</el-button>
        <el-button type="primary" @click="dialogVisible = false">
          通过
        </el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script setup>
import { ref } from "vue";

const visible = ref(false);
</script>

<style lang="scss" scoped></style>
